// frontend/src/lib/visitorSession.js
//
// A stable per-browser id for grouping this visitor's page views
// (apps.analytics.models.PageView.session_id) without requiring a login.
// Not an auth token — just lets "how many pages did one visitor look at"
// be answered later.

const SESSION_KEY = 'vl_session_id';

function randomId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function getVisitorSessionId() {
  try {
    let id = window.localStorage.getItem(SESSION_KEY);
    if (!id) {
      id = randomId();
      window.localStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    // Private browsing / storage disabled — the view still gets tracked,
    // it just won't group with this visitor's other page views.
    return randomId();
  }
}
